export const SET_CAR_LIST = 'SET_CAR_LIST';
export const SET_BROCHURES = 'SET_BROCHURES';
export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER_AGREE = 'SET_USER_AGREE';
export const SET_SUBMIT_STATUS = 'SET_SUBMIT_STATUS';
export const RESET = 'RESET';

export function setCarList(carList) {
  return {
    type: SET_CAR_LIST,
    carList
  };
}

export function setBrochures(brochures) {
  return {
    type: SET_BROCHURES,
    brochures
  };
}

export function reset() {
  return {
    type: RESET,
  };
}

export function setUserName(name) {
  return {
    type: SET_USER_NAME,
    name
  };
}

export function setUserEmail(email) {
  return {
    type: SET_USER_EMAIL,
    email
  };
}

export function setUserAgree(news_subscription) {
  return {
    type: SET_USER_AGREE,
    news_subscription
  };
}

export function setSubmitStatus(submitStatus) {
  return {
    type: SET_SUBMIT_STATUS,
    submitStatus
  };
}



// WEBPACK FOOTER //
// ./src/actions.js